/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ButtonBase } from './ButtonBase';

const IconButton = React.forwardRef((props, ref) => {

  const {
    icon: Icon,
    color = 'primary',
    iconSize = 'small',
    buttonSize = 'normal',
    ...rest
  } = props;

  const focusStyles = 'focus-visible:sui-outline focus-visible:sui-outline-2 focus-visible:sui-outline-warning';
  const colorStyle = 'hover:sui-text-brand disabled:!sui-text-inactive';
  const buttonClasses = classNames('sui-inline-flex sui-items-center sui-justify-center sui-border-none sui-border-0',
    colorStyle, focusStyles,
    {
      'sui-h-6 sui-w-6': buttonSize === 'tight',
      'sui-h-8 sui-w-8': buttonSize === 'normal',
      'sui-h-11 sui-w-11': buttonSize === 'relaxed',
      'sui-text-primary': color === 'primary',
      'sui-text-success': color === 'success',
      'sui-text-subtle': color === 'subtle',
      'sui-text-inherit': color === 'inherit',
    });

  if (buttonSize === 'tight' && iconSize === 'large') {
    // eslint-disable-next-line no-console
    console.error('A large icon size is not supported on a tight icon button');
  }
  const sizedIcon = Icon && (<Icon size={iconSize} />);

  return (
    <ButtonBase ref={ref} unstyled className={buttonClasses} {...rest}>
      {sizedIcon}
    </ButtonBase>
  );
});

IconButton.displayName = 'IconButton';

IconButton.propTypes = {
  /**
   * The icon of the component.
   */
  icon: PropTypes.elementType,
  /**
   * @ignore
   * The icon color
   */
  color: PropTypes.string,
  /**
   * Defines the button (container) size
   * @default 'normal'
   */
  buttonSize: PropTypes.oneOf(['tight', 'normal', 'relaxed']),
  /**
   * Defines the icon size
   * @default 'small'
   */
  iconSize: PropTypes.oneOf(['small', 'regular', 'large'])
};

IconButton.defaultProps = {
};

export { IconButton };